import Stamp from './Stamp';

export default Stamp;
